<template>
    <rkm-table
        :fields="fields"
        :items="data.model.encaminhamentos.filter(encaminhamento => encaminhamento.deleted === false)"
    >
        <template v-slot:cell(ocupacao)="{item}">
            {{item.ocupacao.codigo}} - {{item.ocupacao.nome}}
        </template>

        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="$emit('edit', item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    data: () => ({
        fields: [
            {key: 'ocupacao', label: 'CBO Solicitante'},
            {key: 'unidadesDescricao', label: 'Unidade'},
            {key: 'infraestruturasDescricao', label: 'Local de atendimento'},
            {key: 'especialidadesDescricao', label: 'Especialidades permitidas'},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
    }),
    methods: {
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir o encaminhamento?', async () => {
                item.deleted = true
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
